var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1104 3.71582C7.54284 3.71582 3.8269 7.43176 3.8269 11.9993C3.8269 16.5668 7.54284 20.2827 12.1104 20.2827C16.6779 20.2827 20.3938 16.5668 20.3938 11.9993C20.3938 7.43176 16.6779 3.71582 12.1104 3.71582ZM12.8033 15.6686C12.8033 16.06 12.486 16.3772 12.0946 16.3772C11.7032 16.3772 11.386 16.06 11.386 15.6686V15.5741C11.386 15.1827 11.7032 14.8654 12.0946 14.8654C12.486 14.8654 12.8033 15.1827 12.8033 15.5741V15.6686ZM12.8033 12.7079C12.8033 13.0993 12.486 13.4166 12.0946 13.4166C11.7032 13.4166 11.386 13.0993 11.386 12.7079V8.32996C11.386 7.93858 11.7032 7.6213 12.0946 7.6213C12.486 7.6213 12.8033 7.93858 12.8033 8.32996V12.7079Z",
    fill: "#E9655B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/alarm.3c5402e3e07928999ac7b040966cf41e.svg";
export { ForwardRef as ReactComponent };